import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormikContext } from 'formik';
import { isEmpty } from 'lodash-es';

import { ReactComponent as uploadIcon } from '../../../../../assets/images/uploadUpward.svg';
import Notification from '../../../../../components/Notification/Notification';
import AttachFile from '../../../../../components/shared/AttachFile/AttachFile';

import AdditionalURL from './AdditionalURL/AdditionalURL';

import styles from './CandidateStrengthenStep1.module.scss';

const CandidateStrengthenStep1 = () => {
  const { t } = useTranslation('common');
  const { values, setValues } = useFormikContext();

  const { files } = values;

  const handleFileDelete = useCallback(
    (data) => {
      const index = files.findIndex((file) => (file.name ?? file[0].name) === (data.name ?? data[0].name));
      const newData = [...files];

      if (index !== -1) {
        let selectedFile = files[index];
        if (selectedFile.id) {
          selectedFile = { ...selectedFile, _destroy: true };
          newData[index] = selectedFile;
        } else {
          newData.splice(index, 1);
        }
      }

      setValues((prevValues) => ({ ...prevValues, files: newData }));
    },
    [values]
  );

  const handleFileUpload = useCallback(
    (data) => {
      if (data.length === 0) {
        Notification.error(t('validation.onlyPdfOrWord'));
        return;
      }
      const index = files.findIndex((file) => (file.name ?? file[0].name) === data[0].name);
      if (index === -1) {
        const newData = [...values.files, data];
        setValues((prevValues) => ({ ...prevValues, files: newData }));
      } else {
        Notification.error(t('validation.fileAlreadyPresent'));
      }
    },
    [values, t]
  );

  return (
    <div>
      <Field
        name="files"
        as={AttachFile}
        acceptedFiles={isEmpty(files) ? [] : files}
        handleFileDelete={handleFileDelete}
        handleOnDrop={handleFileUpload}
        accept={{ 'text/pdf': ['.pdf'], 'application/msword': ['.doc', '.docx'] }}
        DropzoneIcon={uploadIcon}
      />

      <div className={styles.separatorLine} />

      <AdditionalURL />
    </div>
  );
};

export default CandidateStrengthenStep1;
